
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, computed } from 'vue'
import { ClockCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtopF10.vue'
import Descriptions from '@/components/descriptions.vue'
import Nodata from '@/components/page/nodata.vue'
import api from '@/api/allApi'
import f10ApiUS from '@/api/f10ApiUS'
import { isLocalDev } from '@/api/config'
export default defineComponent({
  components: { Descriptions, Nodata },
  props: {
    itemdata: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    theme: {
      type: String,
      default: function () {
        return 'light'
      }
    },
    token: {
      type: String,
      default: function () {
        return ''
      }
    }
  },
  setup(props: any, context) {
    const pageData: any = reactive({
      list: [],
      opencontent1: false,
      opencontent2: false,
      open1: false,
      open2: false,
      spinning: true
    })
    // 加载数据
    const loadData = () => {
      const route: any = useRoute()
      const market = isLocalDev ? 'NASDAQ' : (route.query.market as string)
      const symbol = isLocalDev ? 'AAPL' : (route.query.code as string)

      // 准备两个接口的数据
      const zjzlData = {
        data: {
          market,
          symbol,
        },
        headers: {
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
        }
      }

      const etfData = {
        data: {
          symbol,
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944',
        },
        headers: {},
      }

      // 分别调用两个接口
      // 调用getZjzl接口获取所属行业和主营业务
      f10ApiUS.getZjzl(zjzlData).then((zjzlRes: any) => {
        let industryName = '—'
        let mainOperationBusiness = '—'

        // 处理getZjzl返回的数据（所属行业和主营业务）
        if (zjzlRes && zjzlRes.data) {
          const zjzlRaw = zjzlRes.data
          industryName = zjzlRaw.industryName || '—'
          mainOperationBusiness = zjzlRaw.mainOperationBusiness || '—'
        }

        // 更新页面数据
        pageData.industryName = industryName
        pageData.mainOperationBusiness = mainOperationBusiness

        // 更新列表数据
        if (pageData.list && pageData.list.length > 0) {
          const industryItem = pageData.list.find((item: any) => item.key === 'industryName')
          const businessItem = pageData.list.find((item: any) => item.key === 'mainOperationBusiness')
          if (industryItem) industryItem.content = industryName
          if (businessItem) businessItem.content = mainOperationBusiness
        }
      }).catch((error) => {
        console.error('获取所属行业和主营业务失败:', error)
        pageData.industryName = '—'
        pageData.mainOperationBusiness = '—'
      })

      // 调用getBriefbaseInfo2接口获取所属ETF
      f10ApiUS.getBriefbaseInfo2(etfData).then((etfRes: any) => {
        let etfNames = '—'

        // 处理getBriefbaseInfo2返回的数据（所属ETF）
        if (etfRes && etfRes.data) {
          const etfRaw = etfRes.data
          if (etfRaw.relate_etf && etfRaw.relate_etf.list && Array.isArray(etfRaw.relate_etf.list)) {
            const names = etfRaw.relate_etf.list
              .map((item: any) => item.symbol_info?.name)
              .filter((name: string) => name) // 过滤掉空值
            etfNames = names.length > 0 ? names.join('，') : '—'
          }
        }

        // 更新页面数据
        pageData.etfNames = etfNames

        // 更新列表数据
        if (pageData.list && pageData.list.length > 0) {
          const etfItem = pageData.list.find((item: any) => item.key === 'relateEtf')
          if (etfItem) etfItem.content = etfNames
        }
      }).catch((error) => {
        console.error('获取所属ETF失败:', error)
        pageData.etfNames = '—'
      })

      // 初始化列表数据
      const list = [
        {
          title: '所属行业',
          key: 'industryName',
          content: '—',
          opencontent: false,
          width: '150px',
          open: false
        },
        {
          title: '所属ETF',
          key: 'relateEtf',
          content: '—',
          opencontent: false,
          width: '150px',
          open: false
        },
        {
          title: '主营业务',
          key: 'mainOperationBusiness',
          content: '—',
          opencontent: false,
          open: false,
          collapse: true
        }
      ]

      pageData.list = list
      pageData.spinning = false
    }

    onMounted(() => {
      loadData()
    })

    return {
      ...toRefs(pageData)
    }
  }
})
